import { useOpstelClient } from "@opstel/contexts/opstelClient/useOpstelClient";
import { instances } from "@opstel/query/queryKeys/instanceKeys";
import { RawAction } from "@opstel/query/v2/opstelClient";
import { actionSchema } from "@opstel/query/v2/actionParser";
import { useCurrentInstanceId } from "@shared/common/contexts/instanceMetadata/useInstanceId";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import z from "zod";

// Extracted as separate function to keep reference stable over renders
function parseActions(rawAction: RawAction[]) {
  const result = z.array(actionSchema).safeParse(rawAction);
  if (!result.success) {
    console.error(result.error);
    throw result.error;
  }
  return result.data;
}

export function useCachedActions() {
  const { instanceId } = useCurrentInstanceId();
  const { opstelClient } = useOpstelClient();
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: instances.current(instanceId).actions,
    queryFn: async () => {
      const actions = await opstelClient.getActions({ instanceId: instanceId ?? "" });

      actions?.forEach((action) => {
        queryClient.setQueryData(
          instances.current(instanceId).action(action.id).everything,
          action,
        );
      });

      return actions;
    },
    select: parseActions,
    enabled: instanceId !== undefined,
  });
}
